<template lang="html">
  <div v-if="active" class="marketplace-icon rounded-circle d-flex align-items-center justify-content-center">
    <font-awesome-icon :icon="[ 'fas', 'shopping-cart' ]" />
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
  }
}
</script>

<style lang="css" scoped>
.marketplace-icon {
  position: absolute;
  background-color: #20c997;
  color: #ffffff;
  left: 5px;
  top: 40%;
  z-index: 1;
  height: 30px;
  width: 30px;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/MarketplaceIcon.vue